"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SynthRegistryFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var SynthRegistryFactory = /** @class */ (function (_super) {
    __extends(SynthRegistryFactory, _super);
    function SynthRegistryFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    SynthRegistryFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    SynthRegistryFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    SynthRegistryFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    SynthRegistryFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    SynthRegistryFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return SynthRegistryFactory;
}(contracts_1.ContractFactory));
exports.SynthRegistryFactory = SynthRegistryFactory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "currencyKey",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "address",
                name: "synth",
                type: "address",
            },
        ],
        name: "SynthAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "currencyKey",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "address",
                name: "synth",
                type: "address",
            },
        ],
        name: "SynthRemoved",
        type: "event",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "proxy",
                type: "address",
            },
            {
                internalType: "address",
                name: "synth",
                type: "address",
            },
        ],
        name: "addSynth",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "availableSynths",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "getAllSynths",
        outputs: [
            {
                internalType: "address[]",
                name: "",
                type: "address[]",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bytes32",
                name: "symbolKey",
                type: "bytes32",
            },
        ],
        name: "removeSynth",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "synths",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "synthsByAddress",
        outputs: [
            {
                internalType: "bytes32",
                name: "symbolKey",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "proxyAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "syntheticAddress",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
//# sourceMappingURL=SynthRegistryFactory.js.map